import { CloseCircleOutlined } from "@ant-design/icons";
import { Popover, Space, Tooltip, Typography } from "antd";
import type { PopoverProps } from "antd";
import { useCallback, useMemo, useRef, useState } from "react";
import { useTheme } from "styled-components";

import localStorage from "legacy/utils/localStorage";
import { STORAGE_KEYS } from "legacy/utils/StorageUtils";

export const IntercomPopover = (props: PopoverProps) => {
  const theme = useTheme();
  const [hasDismissed, setHasDismissed] = useState(
    !!localStorage.getItem(STORAGE_KEYS.SHOW_INTERCOM_POPOVER_KEY),
  );

  const chatPrompt = "Chat with a Superblocks Engineer";

  const onDismiss = useCallback(() => {
    localStorage.setItem(STORAGE_KEYS.SHOW_INTERCOM_POPOVER_KEY, "true");
    setHasDismissed(true);
  }, []);

  const content = useMemo(
    () => (
      <Space direction="horizontal">
        <Typography.Text>{chatPrompt}</Typography.Text>
        <CloseCircleOutlined
          style={{ cursor: "pointer", color: theme.colors.GREY_300 }}
          onClick={onDismiss}
        />
      </Space>
    ),
    [onDismiss, theme.colors.GREY_300],
  );
  const popoverRef = useRef<any>();

  return (
    <Popover
      content={content}
      placement="right"
      open={!hasDismissed}
      ref={(el) => {
        popoverRef.current = el;
      }}
    >
      {hasDismissed ? (
        <Tooltip title={chatPrompt} placement="right">
          {props.children}
        </Tooltip>
      ) : (
        props.children
      )}
    </Popover>
  );
};
